/**
 * index.ts - Backtrackr - Comprehensive Versioning System
 * 
 * CHANGE HISTORY:
 * - 251118_0442 danielbeer: Add TypeScript type definitions for BacktrackrContext
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
export { default as HistoryManager } from './HistoryManager';
export { default as HistoryViewer } from './HistoryViewer';
export { 
  BacktrackrContext, 
  BacktrackrProvider, 
  useBacktrackr,
  type BacktrackrContextValue 
} from './BacktrackrContext';
export { useBacktrackrContext } from './hooks/useBacktrackrContext';

// Singleton instance for convenience
let instance = null;

/**
 * Get singleton HistoryManager instance
 */
export async function getBacktrackr(options) {
  if (!instance) {
    const { default: HistoryManager } = await import('./HistoryManager.js');
    instance = new HistoryManager(options);
  }
  return instance;
}

/**
 * Convenience wrapper for Deployr integration
 */
export class BacktrackrAdapter {
  constructor() {
    this.manager = null;
  }

  async initialize() {
    if (!this.manager) {
      const { default: HistoryManager } = await import('./HistoryManager.js');
      this.manager = new HistoryManager();
    }
  }

  async track(change) {
    await this.initialize();
    return this.manager.recordChange({
      type: change.type || 'change',
      description: change.description || 'Change recorded',
      context: change.context,
      before: change.before,
      after: change.after,
      metadata: change.metadata
    });
  }

  async undo(changeId) {
    await this.initialize();
    return this.manager.undo();
  }

  async getHistory(type) {
    await this.initialize();
    const history = this.manager.getHistory();
    if (type) {
      return history.filter(h => h.type === type);
    }
    return history;
  }
}

// Export adapter as default for Deployr
let adapterInstance = null;

export function getBacktrackrAdapter() {
  if (!adapterInstance) {
    adapterInstance = new BacktrackrAdapter();
  }
  return adapterInstance;
}

export default getBacktrackrAdapter;
